import PropTypes from 'prop-types';

export const userPropType = PropTypes.shape({
  email: PropTypes.string
});
